export const config = {
  storagePrefix: 'lcm',
  clientId: window.env.CLIENT_ID,
  iumBaseUrl: window.env.IUM_BASE_URL,
  appBaseUrl: window.env.BASE_URL,
  appEnvId: window.env.APP_ENV_ID,
  refreshInterval: 300000,
};
export default config;